// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Xusu","footer":"styles_footer__2fL36","passCodeTooltip":"styles_passCodeTooltip__3M6QJ"};